<template>
  <div class="mb-3">
    <label :for="id"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, handleChange, meta }"
    >
      <div>
        <el-upload
          :action="'#'"
          :limit="limit"
          :accept="'.pdf,.doc,.docx,.xls,.xlsx,.txt'"
          :multiple="limit > 1"
          :show-file-list="true"
          :auto-upload="false"
          :on-change="(file) => handleUpload(file, handleChange)"
          :file-list="fileList"
        >
          <el-button class="btn btn-secondary text-muted">
            <i class="el-icon-upload"></i>
            Seleccionar archivo{{ limit > 1 ? "s" : "" }}
          </el-button>
          <br />
        </el-upload>
        <small v-if="limit" class="mt-1"
          >Maximo de {{ limit }} archivo(s)</small
        >
      </div>
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
import { ref } from "vue";

const fileList = ref([]);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  limit: {
    type: Number,
    default: 1,
  },
  fieldName: {
    type: String,
    default: "",
  },
  uploadType: {
    type: String,
    default: "file",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});

const handleUpload = (file, handleChange) => {
  fileList.value = fileList.value.slice(0, props.limit - 1);
  fileList.value.push(file);

  handleChange(file.raw);
};
</script>
